// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chapito-smartbanner {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999999;
  width: 100%;
  height: var(--banner-height);
  display: grid;
  align-items: center;
  grid-template-areas:
    'a b c c'
    'a b d e'
    'a b f e'
    'a b f .';
  grid-template-rows: auto auto auto auto;
  grid-template-columns: max-content max-content auto 1fr;
  column-gap: 8px;
  row-gap: 3px;
  padding: 10px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Arial, sans-serif;

  --banner-bg: #f3f3f3;
  --banner-height: 84px;
  --text-color: #000;
  --subtext-color: #555;
  --border-color: rgba(0, 0, 0, 0.1);
  --exit-color: #868686;
  --button-ios-bg: #1474fc;
  --button-android-bg: #1474fc;
  --button-text-color: #fff;

  background-color: var(--banner-bg);
  color: var(--text-color);
  border-top: 1px solid var(--border-color);
  transition: background-color 0.4s ease, color 0.4s ease;
}

/* Mode sombre */
@media (prefers-color-scheme: dark) {
  .chapito-smartbanner {
    --banner-bg: #121212;
    --text-color: #f1f1f1;
    --subtext-color: #aaa;
    --border-color: rgba(255, 255, 255, 0.15);
    --exit-color: #aaa;
    --button-ios-bg: #0a84ff;
    --button-android-bg: #3ddc84;
    --button-text-color: #000;
  }
}

.smartbanner__exit {
  grid-area: a;
  width: 16px;
  height: 16px;
  position: relative;
}
.smartbanner__exit::before,
.smartbanner__exit::after {
  content: '';
  position: absolute;
  left: 7px;
  top: 0;
  width: 2px;
  height: 16px;
  background: var(--exit-color) !important;
}
.smartbanner__exit::before {
  transform: rotate(45deg);
}
.smartbanner__exit::after {
  transform: rotate(-45deg);
}

.smartbanner__icon {
  grid-area: b;
  border-radius: 13px;
  background-size: contain;
  background-position: center;
  height: calc(var(--banner-height) - 20px);
  width: calc(var(--banner-height) - 20px);
  background-color: #fff;
}

.smartbanner__info__title {
  grid-area: c;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-color) !important;
}

.smartbanner__info__festival-name {
  grid-area: d;
  font-size: 12px;
  color: var(--subtext-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.smartbanner__info__price {
  grid-area: f;
  font-size: 11px;
  color: var(--subtext-color) !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
}

.smartbanner__button {
  grid-area: e;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2em;
  padding: 0 15px;
  border-radius: 1em;
  font-size: 14px;
  text-decoration: none;
  justify-self: end;
  color: var(--button-text-color) !important;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.smartbanner--ios .smartbanner__button {
  background-color: var(--button-ios-bg) !important;
}

.smartbanner--android .smartbanner__button {
  background-color: var(--button-android-bg) !important;
}
`, "",{"version":3,"sources":["webpack://./web/smartbanner/smartbanner.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB;;;;aAIW;EACX,uCAAuC;EACvC,uDAAuD;EACvD,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8FAA8F;;EAE9F,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;EAClC,qBAAqB;EACrB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;;EAEzB,kCAAkC;EAClC,wBAAwB;EACxB,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA,gBAAgB;AAChB;EACE;IACE,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,yCAAyC;IACzC,kBAAkB;IAClB,wBAAwB;IACxB,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,UAAU;EACV,YAAY;EACZ,wCAAwC;AAC1C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,2BAA2B;EAC3B,yCAAyC;EACzC,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,0CAA0C;EAC1C,uDAAuD;AACzD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qDAAqD;AACvD","sourcesContent":[".chapito-smartbanner {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 9999999;\n  width: 100%;\n  height: var(--banner-height);\n  display: grid;\n  align-items: center;\n  grid-template-areas:\n    'a b c c'\n    'a b d e'\n    'a b f e'\n    'a b f .';\n  grid-template-rows: auto auto auto auto;\n  grid-template-columns: max-content max-content auto 1fr;\n  column-gap: 8px;\n  row-gap: 3px;\n  padding: 10px;\n  box-sizing: border-box;\n  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Arial, sans-serif;\n\n  --banner-bg: #f3f3f3;\n  --banner-height: 84px;\n  --text-color: #000;\n  --subtext-color: #555;\n  --border-color: rgba(0, 0, 0, 0.1);\n  --exit-color: #868686;\n  --button-ios-bg: #1474fc;\n  --button-android-bg: #1474fc;\n  --button-text-color: #fff;\n\n  background-color: var(--banner-bg);\n  color: var(--text-color);\n  border-top: 1px solid var(--border-color);\n  transition: background-color 0.4s ease, color 0.4s ease;\n}\n\n/* Mode sombre */\n@media (prefers-color-scheme: dark) {\n  .chapito-smartbanner {\n    --banner-bg: #121212;\n    --text-color: #f1f1f1;\n    --subtext-color: #aaa;\n    --border-color: rgba(255, 255, 255, 0.15);\n    --exit-color: #aaa;\n    --button-ios-bg: #0a84ff;\n    --button-android-bg: #3ddc84;\n    --button-text-color: #000;\n  }\n}\n\n.smartbanner__exit {\n  grid-area: a;\n  width: 16px;\n  height: 16px;\n  position: relative;\n}\n.smartbanner__exit::before,\n.smartbanner__exit::after {\n  content: '';\n  position: absolute;\n  left: 7px;\n  top: 0;\n  width: 2px;\n  height: 16px;\n  background: var(--exit-color) !important;\n}\n.smartbanner__exit::before {\n  transform: rotate(45deg);\n}\n.smartbanner__exit::after {\n  transform: rotate(-45deg);\n}\n\n.smartbanner__icon {\n  grid-area: b;\n  border-radius: 13px;\n  background-size: contain;\n  background-position: center;\n  height: calc(var(--banner-height) - 20px);\n  width: calc(var(--banner-height) - 20px);\n  background-color: #fff;\n}\n\n.smartbanner__info__title {\n  grid-area: c;\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--text-color) !important;\n}\n\n.smartbanner__info__festival-name {\n  grid-area: d;\n  font-size: 12px;\n  color: var(--subtext-color);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.smartbanner__info__price {\n  grid-area: f;\n  font-size: 11px;\n  color: var(--subtext-color) !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-decoration: none;\n}\n\n.smartbanner__button {\n  grid-area: e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 2em;\n  padding: 0 15px;\n  border-radius: 1em;\n  font-size: 14px;\n  text-decoration: none;\n  justify-self: end;\n  color: var(--button-text-color) !important;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.smartbanner--ios .smartbanner__button {\n  background-color: var(--button-ios-bg) !important;\n}\n\n.smartbanner--android .smartbanner__button {\n  background-color: var(--button-android-bg) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
